import axios from 'axios';
import _ from 'lodash';

import ParkinglocationModel from './ParkinglocationModel.js';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/checker/parkings';

export default new class CheckingParkingModel {

  getByParkinglocation(parkinglocation, date = null) {
    let params = {
      access_token: UserModel.getAccessToken(),
      parkinglocation: parkinglocation
    };
    if (date) {
      params.timestamp = date.format()
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: params
      }).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getAll(parkinglocation, licenceplate = null, timestamp = null) {
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          parkinglocation: parkinglocation,
          licenceplate: licenceplate,
          timestamp: timestamp
        }
      }).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/CheckingParkingModel.js